import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navLinks = [
  { to: '/', label: 'Home', end: true },
  { to: '/treatments', label: 'Treatments' },
  { to: '/conditions', label: 'Conditions' },
  { to: '/reviews', label: 'Reviews' },
  { to: '/about-doctor', label: 'Doctor' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact', label: 'Contact' },
];

const Header = ({ onBook }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleBook = () => {
    if (onBook) onBook();
  };

  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner">
        <Link to="/" className="header-logo" data-testid="site-logo" aria-label="Siddhayu Ayurvedic Clinic home">
          <div className="logo-circle">
            <img src="/siddhayu-logo.png" alt="Siddhayu Ayurvedic Clinic logo" />
          </div>
          <div className="logo-text">
            <span className="clinic-name">सिद्धायु आयुर्वेद</span>
            <span className="clinic-subtitle">Clinic &amp; Panchakarma Centre</span>
          </div>
        </Link>

        <nav className="header-nav" data-testid="desktop-nav" aria-label="Main navigation">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className="nav-link">{l.label}</NavLink>
          ))}
        </nav>

        <div className="header-actions">
          <button className="btn-book" onClick={handleBook} data-testid="book-consultation-btn" aria-label="Open appointment booking form">
            Book Consultation
          </button>
          <button className="hamburger" onClick={() => setMenuOpen((o) => !o)} aria-label="Toggle navigation menu" aria-expanded={menuOpen} data-testid="hamburger-btn">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      <nav className={`mobile-menu${menuOpen ? ' open' : ''}`} data-testid="mobile-menu" aria-label="Mobile navigation">
        {menuOpen && (
          <button className="mobile-menu-close" onClick={() => setMenuOpen(false)} aria-label="Close navigation menu" data-testid="mobile-menu-close">✕</button>
        )}
        {navLinks.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end} className="nav-link" onClick={() => setMenuOpen(false)}>{l.label}</NavLink>
        ))}
        <button className="btn-book" onClick={() => { setMenuOpen(false); handleBook(); }} style={{ marginTop: '1rem', minWidth: '200px', justifyContent: 'center', display: 'inline-flex', minHeight: '48px', fontSize: '1rem' }} aria-label="Open appointment booking form">
          Book Consultation
        </button>
      </nav>
    </header>
  );
};

export default Header;
